var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 94,
    viewBox: "0 0 74 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80421 77.81V84.544C8.91621 84.586 9.39221 84.642 10.2742 84.642C12.8082 84.642 14.1942 83.382 14.1942 81.184C14.1942 79.168 13.0042 77.726 10.2742 77.726C9.37821 77.726 8.87421 77.796 8.80421 77.81ZM7.13821 86V77.306C7.13821 76.34 7.79621 76.256 10.2462 76.256C13.7882 76.256 15.9442 78.146 15.9442 81.184C15.9442 84.25 13.9002 86.14 10.1342 86.14C8.13221 86.14 7.23621 86.014 7.13821 86ZM17.4435 86V79.714C17.4435 79.196 17.7515 78.972 18.2975 78.972C18.6335 78.972 18.9415 79.084 19.0395 79.126V86H17.4435ZM18.2415 75.822C18.7875 75.822 19.2075 76.242 19.2075 76.788C19.2075 77.334 18.7875 77.754 18.2415 77.754C17.6955 77.754 17.2755 77.334 17.2755 76.788C17.2755 76.242 17.6955 75.822 18.2415 75.822ZM20.3305 85.328L20.9325 84.25C21.1845 84.432 22.3185 84.95 23.7885 84.95C24.7545 84.95 25.4405 84.726 25.4405 84.11C25.4405 83.592 25.1045 83.34 24.0965 83.228L23.0045 83.102C21.5065 82.948 20.4565 82.36 20.4565 80.988C20.4565 79.798 21.3385 78.776 23.6485 78.776C25.5945 78.776 26.7145 79.252 26.7145 79.938C26.7145 80.358 26.3365 80.652 26.2245 80.694C26.0705 80.54 25.2165 79.98 23.6625 79.98C22.5845 79.98 22.0385 80.26 22.0385 80.834C22.0385 81.324 22.4585 81.548 23.2285 81.646L24.6565 81.828C26.2105 82.038 27.1065 82.64 27.1065 83.886C27.1065 85.286 25.9585 86.196 23.8725 86.196C21.8705 86.196 20.5405 85.51 20.3305 85.328ZM28.4761 83.886V77.726C28.4761 77.208 28.7981 76.984 29.3161 76.984C29.6521 76.984 29.9741 77.096 30.0721 77.138V78.972H32.1021C32.7181 78.972 32.9421 79.224 32.9421 79.714C32.9421 80.036 32.8161 80.33 32.7601 80.442H30.0721V83.564C30.0721 84.516 30.6461 84.782 31.3321 84.782C31.8781 84.782 32.3821 84.572 32.5921 84.418L33.2361 85.482C32.9281 85.706 32.1301 86.196 30.9681 86.196C29.3301 86.196 28.4761 85.272 28.4761 83.886ZM34.0669 86V81.478C34.0669 79.756 35.1869 78.776 37.0489 78.776C38.2249 78.776 39.0369 79.098 39.0369 79.77C39.0369 80.092 38.7989 80.442 38.6869 80.512C38.3649 80.358 37.9029 80.204 37.3009 80.204C36.2089 80.204 35.6629 80.778 35.6629 81.94V86H34.0669ZM39.9611 86V79.714C39.9611 79.196 40.2691 78.972 40.8151 78.972C41.1511 78.972 41.4591 79.084 41.5571 79.126V86H39.9611ZM40.7591 75.822C41.3051 75.822 41.7251 76.242 41.7251 76.788C41.7251 77.334 41.3051 77.754 40.7591 77.754C40.2131 77.754 39.7931 77.334 39.7931 76.788C39.7931 76.242 40.2131 75.822 40.7591 75.822ZM43.1001 82.15V76.424C43.1001 75.92 43.4081 75.682 43.9541 75.682C44.2901 75.682 44.5981 75.794 44.6961 75.836V79.854C45.1581 79.252 46.0121 78.776 47.0761 78.776C49.1201 78.776 50.6601 80.316 50.6601 82.486C50.6601 84.628 49.0781 86.196 46.8801 86.196C44.6821 86.196 43.1001 84.866 43.1001 82.15ZM46.8521 84.754C48.1401 84.754 49.0081 83.774 49.0081 82.486C49.0081 81.184 48.1401 80.204 46.8521 80.204C45.5641 80.204 44.6821 81.198 44.6821 82.486C44.6821 83.83 45.5781 84.754 46.8521 84.754ZM52.0181 83.158V79.714C52.0181 79.196 52.3261 78.972 52.8721 78.972C53.2081 78.972 53.5161 79.084 53.6141 79.126V82.808C53.6141 84.082 54.2021 84.754 55.4341 84.754C56.6661 84.754 57.2541 84.082 57.2541 82.808V79.714C57.2541 79.196 57.5761 78.972 58.0941 78.972C58.4441 78.972 58.7521 79.084 58.8501 79.126V83.158C58.8501 85.076 57.4641 86.196 55.4341 86.196C53.4181 86.196 52.0181 85.076 52.0181 83.158ZM60.5646 86V79.714C60.5646 79.196 60.8726 78.972 61.4186 78.972C61.7546 78.972 62.0626 79.084 62.1606 79.126V86H60.5646ZM61.3626 75.822C61.9086 75.822 62.3286 76.242 62.3286 76.788C62.3286 77.334 61.9086 77.754 61.3626 77.754C60.8166 77.754 60.3966 77.334 60.3966 76.788C60.3966 76.242 60.8166 75.822 61.3626 75.822ZM63.8716 86V81.478C63.8716 79.756 64.9916 78.776 66.8536 78.776C68.0296 78.776 68.8416 79.098 68.8416 79.77C68.8416 80.092 68.6036 80.442 68.4916 80.512C68.1696 80.358 67.7076 80.204 67.1056 80.204C66.0136 80.204 65.4676 80.778 65.4676 81.94V86H63.8716Z",
    fill: "#FF2D55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10322_5042)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.875 38.1875C33.875 39.4 34.8125 40.375 35.9625 40.375H38.3125C39.3125 40.375 40.125 39.525 40.125 38.4625C40.125 37.325 39.625 36.9125 38.8875 36.65L35.125 35.3375C34.3875 35.075 33.8875 34.675 33.8875 33.525C33.8875 32.475 34.7 31.6125 35.7 31.6125H38.05C39.2 31.6125 40.1375 32.5875 40.1375 33.8",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 30.375V41.625",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 36C49.5 42.9 43.9 48.5 37 48.5C30.1 48.5 24.5 42.9 24.5 36C24.5 29.1 30.1 23.5 37 23.5",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 28.5V23.5H44.5",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.25 29.75L49.5 23.5",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10322_5042",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10322_5042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10322_5042",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGive);
export default __webpack_public_path__ + "static/media/icon-give.73d6ea6b6ae824d69d764e8b2bdd70e6.svg";
export { ForwardRef as ReactComponent };